{
    "PlaysoundLabel": "Riproduzione dell'audio (richiede il lettore multimediale locale):",
    "ActivewindowLabel": "Finestra attiva (solo browser IE\/Firefox a scheda singola):",
    "AlarmActions_SectionHeader": "Azioni di allarme",
    "AlarmActions_SectionPara": "Quando gli allarmi vengono attivati, la riga del rapporto e\/o la statistica corrispondente lampeggiano. Di seguito è possibile scegliere le azioni aggiuntive che si verificano per il report attualmente attivo quando uno dei suoi allarmi viene attivato per la prima volta.",
    "NAME": "AlarmActions"
}